async function isFetchResponseLMSAuthorizationError(resp) {
  if (resp.status !== 401) {
    return
  }

  const json = await resp.clone().json()
  return json?.message?.type === 'LMS'
}

export { isFetchResponseLMSAuthorizationError }